import dayjs from 'dayjs';

export default interface NotaSituacao {
    codigo: number|EnumNotaSituacao;
    nome: string;
    ativo: boolean;
    dataCriacao: Date | dayjs.Dayjs;
}

export enum EnumNotaSituacao {
    Pendente = 1,
    Emitida,
    Cancelada
}